import React from "react";
import { Text, TextInput, useTranslation } from "@familyzone/component-library";
import { FilteringSourceCriteria } from "../criteriaTypes";

export interface MacCriteriaProps {
  criteria: FilteringSourceCriteria;
  disabled: boolean;
  onChange: (criteria: FilteringSourceCriteria) => void;
}

const MacCriteria: React.FC<MacCriteriaProps> = ({ criteria, disabled, onChange }) => {
  const { t } = useTranslation();

  if (Array.isArray(criteria.conditions)) {
    return <Text>{t("Invalid Criteria")}</Text>;
  }

  const handleChangeMacAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...criteria, conditions: { mac: e.target.value } });
  };

  return (
    <TextInput
      name="mac address"
      placeholder={t("Type MAC Address")}
      isDisabled={disabled}
      value={String(criteria.conditions.mac)}
      onChange={handleChangeMacAddress}
    />
  );
};

export default MacCriteria;
